var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vicon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "15",
        viewBox: "0 0 25 15",
        fill: "currentColor",
      },
    },
    [
      _c("g", { attrs: { "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            d: "M22.88 15H2.12C.95 15 0 14.038 0 12.85h1.272H0v-1.677h.636H0c0-.469.25-.9.655-1.128a2.589 2.589 0 001.31-2.264c0-.977-.53-1.825-1.31-2.264A1.293 1.293 0 010 4.39h.636H0V2.15h1.272H0C0 .963.95 0 2.12 0h20.76C24.05 0 25 .962 25 2.15h-1.272H25v2.292c0 .455-.237.877-.624 1.11a2.59 2.59 0 00-1.246 2.227c0 .95.5 1.78 1.246 2.228.387.232.624.654.624 1.11h-.636H25v1.733h-1.272H25c0 1.188-.95 2.15-2.12 2.15zM1.272 2.15v2.24A3.881 3.881 0 013.236 7.78a3.881 3.881 0 01-1.964 3.392v1.677c0 .475.38.86.848.86h20.76a.854.854 0 00.848-.86v-1.734a3.884 3.884 0 01-1.87-3.337c0-1.422.75-2.665 1.87-3.337V2.15c0-.475-.38-.86-.848-.86H2.12a.854.854 0 00-.848.86z",
          },
        }),
        _c("path", {
          attrs: {
            d: "M7.991 9.931L6.67 7.823l1.066-.595 1.75 2.703H7.992zM5 9.931V5.5h1.321v4.431H5zm.939-1.696V7.222h1.703v1.013H5.94zm1.925-.387l-1.228-.126L8.078 5.5h1.395l-1.61 2.348zm2.583 2.159a2.38 2.38 0 01-.288-.019 3.407 3.407 0 01-.315-.057l.073-1.025a.914.914 0 00.181.019.474.474 0 00.416-.203c.094-.14.159-.333.195-.582.04-.25.064-.54.073-.874L10.85 5.5h3.783v4.431h-1.308V6.215l.289.279h-1.898l.268-.291-.034 1.012c-.013.43-.044.82-.094 1.165-.049.342-.127.635-.234.88a1.29 1.29 0 01-.45.557c-.187.127-.429.19-.724.19zm8.204-.076L17.33 7.823l1.066-.595 1.75 2.703h-1.495zm-2.991 0V5.5h1.32v4.431h-1.32zm.939-1.696V7.222h1.703v1.013h-1.703zm1.924-.387l-1.227-.126L18.738 5.5h1.395l-1.61 2.348z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }